module.exports = __webpack_public_path__ + "static/img/img_4.c9c6434.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code/img_4.jpg
// module id = 91
// module chunks = 20